var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15.5C30 16.6046 29.1046 17.5 28 17.5H2C0.895431 17.5 0 16.6046 0 15.5C0 14.3954 0.89543 13.5 2 13.5H28C29.1046 13.5 30 14.3954 30 15.5Z",
    fill: "#F97316"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 7,
    fill: "white",
    stroke: "#F97316",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.b3969fc1e788f14c8f44f32a1f07acf2.svg";
export { ForwardRef as ReactComponent };